"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OTA Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.59
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleaseChannelApi = exports.ReleaseChannelApiFactory = exports.ReleaseChannelApiFp = exports.ReleaseChannelApiAxiosParamCreator = exports.JobApi = exports.JobApiFactory = exports.JobApiFp = exports.JobApiAxiosParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.FileApi = exports.FileApiFactory = exports.FileApiFp = exports.FileApiAxiosParamCreator = exports.FarmApi = exports.FarmApiFactory = exports.FarmApiFp = exports.FarmApiAxiosParamCreator = exports.DeviceApi = exports.DeviceApiFactory = exports.DeviceApiFp = exports.DeviceApiAxiosParamCreator = exports.IURITypeEnum = exports.ILotaJobStatusEnum = exports.IFileTypeEnum = exports.IEventTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.IEventTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IFileTypeEnum = {
    FIRMWARE: 'FIRMWARE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ILotaJobStatusEnum = {
    STARTED: 'STARTED',
    SETTINGS_SENT: 'SETTINGS_SENT',
    IN_PROGRESS: 'IN_PROGRESS',
    CLEARED: 'CLEARED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IURITypeEnum = {
    S3: 'S3'
};
/**
 * DeviceApi - axios parameter creator
 * @export
 */
var DeviceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create ota device context.
         * @param {ICreateOtaDeviceContextRequestDTO} [iCreateOtaDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOtaDeviceContext: function (iCreateOtaDeviceContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/device/context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateOtaDeviceContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOtaDeviceContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteOtaDeviceContextByID', 'id', id);
                    localVarPath = "/ota/device/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all ota device contexts by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOtaDeviceContextsByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllOtaDeviceContextsByFarmID', 'farmId', farmId);
                    localVarPath = "/ota/device/context/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaDeviceContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getOtaDeviceContextByID', 'id', id);
                    localVarPath = "/ota/device/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {IUpdateOtaDeviceContextRequestDTO} [iUpdateOtaDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOtaDeviceContextByID: function (id, iUpdateOtaDeviceContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateOtaDeviceContextByID', 'id', id);
                    localVarPath = "/ota/device/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateOtaDeviceContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceApiAxiosParamCreator = DeviceApiAxiosParamCreator;
/**
 * DeviceApi - functional programming interface
 * @export
 */
var DeviceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create ota device context.
         * @param {ICreateOtaDeviceContextRequestDTO} [iCreateOtaDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOtaDeviceContext: function (iCreateOtaDeviceContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOtaDeviceContext(iCreateOtaDeviceContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOtaDeviceContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteOtaDeviceContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all ota device contexts by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOtaDeviceContextsByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllOtaDeviceContextsByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaDeviceContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOtaDeviceContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {IUpdateOtaDeviceContextRequestDTO} [iUpdateOtaDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOtaDeviceContextByID: function (id, iUpdateOtaDeviceContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOtaDeviceContextByID(id, iUpdateOtaDeviceContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceApiFp = DeviceApiFp;
/**
 * DeviceApi - factory interface
 * @export
 */
var DeviceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceApiFp)(configuration);
    return {
        /**
         * Create ota device context.
         * @param {ICreateOtaDeviceContextRequestDTO} [iCreateOtaDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOtaDeviceContext: function (iCreateOtaDeviceContextRequestDTO, options) {
            return localVarFp.createOtaDeviceContext(iCreateOtaDeviceContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOtaDeviceContextByID: function (id, options) {
            return localVarFp.deleteOtaDeviceContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all ota device contexts by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOtaDeviceContextsByFarmID: function (farmId, options) {
            return localVarFp.getAllOtaDeviceContextsByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaDeviceContextByID: function (id, options) {
            return localVarFp.getOtaDeviceContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update ota device context by ID.
         * @param {string} id Unique ID of ota device.
         * @param {IUpdateOtaDeviceContextRequestDTO} [iUpdateOtaDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOtaDeviceContextByID: function (id, iUpdateOtaDeviceContextRequestDTO, options) {
            return localVarFp.updateOtaDeviceContextByID(id, iUpdateOtaDeviceContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceApiFactory = DeviceApiFactory;
/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
var DeviceApi = /** @class */ (function (_super) {
    __extends(DeviceApi, _super);
    function DeviceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create ota device context.
     * @param {ICreateOtaDeviceContextRequestDTO} [iCreateOtaDeviceContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.createOtaDeviceContext = function (iCreateOtaDeviceContextRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).createOtaDeviceContext(iCreateOtaDeviceContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete ota device context by ID.
     * @param {string} id Unique ID of ota device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.deleteOtaDeviceContextByID = function (id, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).deleteOtaDeviceContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all ota device contexts by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getAllOtaDeviceContextsByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getAllOtaDeviceContextsByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get ota device context by ID.
     * @param {string} id Unique ID of ota device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getOtaDeviceContextByID = function (id, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getOtaDeviceContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update ota device context by ID.
     * @param {string} id Unique ID of ota device.
     * @param {IUpdateOtaDeviceContextRequestDTO} [iUpdateOtaDeviceContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.updateOtaDeviceContextByID = function (id, iUpdateOtaDeviceContextRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).updateOtaDeviceContextByID(id, iUpdateOtaDeviceContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceApi;
}(base_1.BaseAPI));
exports.DeviceApi = DeviceApi;
/**
 * FarmApi - axios parameter creator
 * @export
 */
var FarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create farm context.
         * @param {ICreateFarmContextRequestDTO} [iCreateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmContext: function (iCreateFarmContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/farm/context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateFarmContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFarmContextByID', 'id', id);
                    localVarPath = "/ota/farm/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farm contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmContexts: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/farm/context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farm lota settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLotaSettings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/farm/settings/lota";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmContextByID', 'id', id);
                    localVarPath = "/ota/farm/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm lota settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLotaSettingsByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmLotaSettingsByID', 'id', id);
                    localVarPath = "/ota/farm/settings/lota/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmContextRequestDTO} [iUpdateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmContextByID: function (id, iUpdateFarmContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmContextByID', 'id', id);
                    localVarPath = "/ota/farm/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm lota settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmLotaSettingsRequestDTO} [iUpdateFarmLotaSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLotaSettingsByID: function (id, iUpdateFarmLotaSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmLotaSettingsByID', 'id', id);
                    localVarPath = "/ota/farm/settings/lota/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmLotaSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmApiAxiosParamCreator = FarmApiAxiosParamCreator;
/**
 * FarmApi - functional programming interface
 * @export
 */
var FarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create farm context.
         * @param {ICreateFarmContextRequestDTO} [iCreateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmContext: function (iCreateFarmContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFarmContext(iCreateFarmContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFarmContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farm contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmContexts: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarmContexts(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farm lota settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLotaSettings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarmLotaSettings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm lota settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLotaSettingsByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmLotaSettingsByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmContextRequestDTO} [iUpdateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmContextByID: function (id, iUpdateFarmContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmContextByID(id, iUpdateFarmContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm lota settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmLotaSettingsRequestDTO} [iUpdateFarmLotaSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLotaSettingsByID: function (id, iUpdateFarmLotaSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmLotaSettingsByID(id, iUpdateFarmLotaSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmApiFp = FarmApiFp;
/**
 * FarmApi - factory interface
 * @export
 */
var FarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmApiFp)(configuration);
    return {
        /**
         * Create farm context.
         * @param {ICreateFarmContextRequestDTO} [iCreateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmContext: function (iCreateFarmContextRequestDTO, options) {
            return localVarFp.createFarmContext(iCreateFarmContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmContextByID: function (id, options) {
            return localVarFp.deleteFarmContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farm contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmContexts: function (options) {
            return localVarFp.getAllFarmContexts(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farm lota settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLotaSettings: function (options) {
            return localVarFp.getAllFarmLotaSettings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmContextByID: function (id, options) {
            return localVarFp.getFarmContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm lota settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLotaSettingsByID: function (id, options) {
            return localVarFp.getFarmLotaSettingsByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmContextRequestDTO} [iUpdateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmContextByID: function (id, iUpdateFarmContextRequestDTO, options) {
            return localVarFp.updateFarmContextByID(id, iUpdateFarmContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm lota settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmLotaSettingsRequestDTO} [iUpdateFarmLotaSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLotaSettingsByID: function (id, iUpdateFarmLotaSettingsRequestDTO, options) {
            return localVarFp.updateFarmLotaSettingsByID(id, iUpdateFarmLotaSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmApiFactory = FarmApiFactory;
/**
 * FarmApi - object-oriented interface
 * @export
 * @class FarmApi
 * @extends {BaseAPI}
 */
var FarmApi = /** @class */ (function (_super) {
    __extends(FarmApi, _super);
    function FarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create farm context.
     * @param {ICreateFarmContextRequestDTO} [iCreateFarmContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.createFarmContext = function (iCreateFarmContextRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).createFarmContext(iCreateFarmContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete farm context by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.deleteFarmContextByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).deleteFarmContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farm contexts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getAllFarmContexts = function (options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getAllFarmContexts(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farm lota settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getAllFarmLotaSettings = function (options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getAllFarmLotaSettings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm context by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getFarmContextByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getFarmContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm lota settings by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getFarmLotaSettingsByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getFarmLotaSettingsByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm context by ID.
     * @param {string} id Unique ID of farm.
     * @param {IUpdateFarmContextRequestDTO} [iUpdateFarmContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.updateFarmContextByID = function (id, iUpdateFarmContextRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).updateFarmContextByID(id, iUpdateFarmContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm lota settings by ID.
     * @param {string} id Unique ID of farm.
     * @param {IUpdateFarmLotaSettingsRequestDTO} [iUpdateFarmLotaSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.updateFarmLotaSettingsByID = function (id, iUpdateFarmLotaSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).updateFarmLotaSettingsByID(id, iUpdateFarmLotaSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmApi;
}(base_1.BaseAPI));
exports.FarmApi = FarmApi;
/**
 * FileApi - axios parameter creator
 * @export
 */
var FileApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create lota file.
         * @param {ICreateLotaFileRequestDTO} [iCreateLotaFileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLotaFile: function (iCreateLotaFileRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/file/lota";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateLotaFileRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all lota file metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLotaFileMetadata: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/file/lota/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get lota file metadata by ID.
         * @param {string} id Unique ID of lota file metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotaFileMetadataByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getLotaFileMetadataByID', 'id', id);
                    localVarPath = "/ota/file/lota/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FileApiAxiosParamCreator = FileApiAxiosParamCreator;
/**
 * FileApi - functional programming interface
 * @export
 */
var FileApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FileApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create lota file.
         * @param {ICreateLotaFileRequestDTO} [iCreateLotaFileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLotaFile: function (iCreateLotaFileRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLotaFile(iCreateLotaFileRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all lota file metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLotaFileMetadata: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllLotaFileMetadata(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get lota file metadata by ID.
         * @param {string} id Unique ID of lota file metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotaFileMetadataByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLotaFileMetadataByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FileApiFp = FileApiFp;
/**
 * FileApi - factory interface
 * @export
 */
var FileApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FileApiFp)(configuration);
    return {
        /**
         * Create lota file.
         * @param {ICreateLotaFileRequestDTO} [iCreateLotaFileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLotaFile: function (iCreateLotaFileRequestDTO, options) {
            return localVarFp.createLotaFile(iCreateLotaFileRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all lota file metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLotaFileMetadata: function (options) {
            return localVarFp.getAllLotaFileMetadata(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get lota file metadata by ID.
         * @param {string} id Unique ID of lota file metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLotaFileMetadataByID: function (id, options) {
            return localVarFp.getLotaFileMetadataByID(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FileApiFactory = FileApiFactory;
/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
var FileApi = /** @class */ (function (_super) {
    __extends(FileApi, _super);
    function FileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create lota file.
     * @param {ICreateLotaFileRequestDTO} [iCreateLotaFileRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    FileApi.prototype.createLotaFile = function (iCreateLotaFileRequestDTO, options) {
        var _this = this;
        return (0, exports.FileApiFp)(this.configuration).createLotaFile(iCreateLotaFileRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all lota file metadata.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    FileApi.prototype.getAllLotaFileMetadata = function (options) {
        var _this = this;
        return (0, exports.FileApiFp)(this.configuration).getAllLotaFileMetadata(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get lota file metadata by ID.
     * @param {string} id Unique ID of lota file metadata.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    FileApi.prototype.getLotaFileMetadataByID = function (id, options) {
        var _this = this;
        return (0, exports.FileApiFp)(this.configuration).getLotaFileMetadataByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FileApi;
}(base_1.BaseAPI));
exports.FileApi = FileApi;
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/health-check";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthCheckApiFp)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return localVarFp.checkHealth(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check service health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.checkHealth = function (options) {
        var _this = this;
        return (0, exports.HealthCheckApiFp)(this.configuration).checkHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthCheckApi;
}(base_1.BaseAPI));
exports.HealthCheckApi = HealthCheckApi;
/**
 * JobApi - axios parameter creator
 * @export
 */
var JobApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create farm lota job.
         * @param {ICreateFarmLotaJobRequestDTO} [iCreateFarmLotaJobRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmLotaJob: function (iCreateFarmLotaJobRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/job/lota";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateFarmLotaJobRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmLotaJobByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFarmLotaJobByFarmID', 'farmId', farmId);
                    localVarPath = "/ota/job/lota/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farm lota jobs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLotaJobs: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/job/lota";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLotaJobByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmLotaJobByFarmID', 'farmId', farmId);
                    localVarPath = "/ota/job/lota/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get OTA job by device ID.
         * @param {string} deviceId Unique ID of device, there is no validation so can be any types of devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaJobByDeviceID: function (deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getOtaJobByDeviceID', 'deviceId', deviceId);
                    localVarPath = "/ota/job/ota/device/{deviceId}"
                        .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get OTA job by release channel ID.
         * @param {string} releaseChannelId Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaJobByReleaseChannelID: function (releaseChannelId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'releaseChannelId' is not null or undefined
                    (0, common_1.assertParamExists)('getOtaJobByReleaseChannelID', 'releaseChannelId', releaseChannelId);
                    localVarPath = "/ota/job/ota/release-channel/{releaseChannelId}"
                        .replace("{".concat("releaseChannelId", "}"), encodeURIComponent(String(releaseChannelId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateFarmLotaJobRequestDTO} [iUpdateFarmLotaJobRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLotaJobByFarmID: function (farmId, iUpdateFarmLotaJobRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmLotaJobByFarmID', 'farmId', farmId);
                    localVarPath = "/ota/job/lota/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmLotaJobRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.JobApiAxiosParamCreator = JobApiAxiosParamCreator;
/**
 * JobApi - functional programming interface
 * @export
 */
var JobApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.JobApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create farm lota job.
         * @param {ICreateFarmLotaJobRequestDTO} [iCreateFarmLotaJobRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmLotaJob: function (iCreateFarmLotaJobRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFarmLotaJob(iCreateFarmLotaJobRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmLotaJobByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFarmLotaJobByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farm lota jobs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLotaJobs: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarmLotaJobs(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLotaJobByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmLotaJobByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get OTA job by device ID.
         * @param {string} deviceId Unique ID of device, there is no validation so can be any types of devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaJobByDeviceID: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOtaJobByDeviceID(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get OTA job by release channel ID.
         * @param {string} releaseChannelId Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaJobByReleaseChannelID: function (releaseChannelId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOtaJobByReleaseChannelID(releaseChannelId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateFarmLotaJobRequestDTO} [iUpdateFarmLotaJobRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLotaJobByFarmID: function (farmId, iUpdateFarmLotaJobRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmLotaJobByFarmID(farmId, iUpdateFarmLotaJobRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.JobApiFp = JobApiFp;
/**
 * JobApi - factory interface
 * @export
 */
var JobApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.JobApiFp)(configuration);
    return {
        /**
         * Create farm lota job.
         * @param {ICreateFarmLotaJobRequestDTO} [iCreateFarmLotaJobRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmLotaJob: function (iCreateFarmLotaJobRequestDTO, options) {
            return localVarFp.createFarmLotaJob(iCreateFarmLotaJobRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmLotaJobByFarmID: function (farmId, options) {
            return localVarFp.deleteFarmLotaJobByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farm lota jobs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLotaJobs: function (options) {
            return localVarFp.getAllFarmLotaJobs(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLotaJobByFarmID: function (farmId, options) {
            return localVarFp.getFarmLotaJobByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get OTA job by device ID.
         * @param {string} deviceId Unique ID of device, there is no validation so can be any types of devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaJobByDeviceID: function (deviceId, options) {
            return localVarFp.getOtaJobByDeviceID(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get OTA job by release channel ID.
         * @param {string} releaseChannelId Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaJobByReleaseChannelID: function (releaseChannelId, options) {
            return localVarFp.getOtaJobByReleaseChannelID(releaseChannelId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm lota job by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateFarmLotaJobRequestDTO} [iUpdateFarmLotaJobRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLotaJobByFarmID: function (farmId, iUpdateFarmLotaJobRequestDTO, options) {
            return localVarFp.updateFarmLotaJobByFarmID(farmId, iUpdateFarmLotaJobRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.JobApiFactory = JobApiFactory;
/**
 * JobApi - object-oriented interface
 * @export
 * @class JobApi
 * @extends {BaseAPI}
 */
var JobApi = /** @class */ (function (_super) {
    __extends(JobApi, _super);
    function JobApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create farm lota job.
     * @param {ICreateFarmLotaJobRequestDTO} [iCreateFarmLotaJobRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    JobApi.prototype.createFarmLotaJob = function (iCreateFarmLotaJobRequestDTO, options) {
        var _this = this;
        return (0, exports.JobApiFp)(this.configuration).createFarmLotaJob(iCreateFarmLotaJobRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete farm lota job by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    JobApi.prototype.deleteFarmLotaJobByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.JobApiFp)(this.configuration).deleteFarmLotaJobByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farm lota jobs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    JobApi.prototype.getAllFarmLotaJobs = function (options) {
        var _this = this;
        return (0, exports.JobApiFp)(this.configuration).getAllFarmLotaJobs(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm lota job by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    JobApi.prototype.getFarmLotaJobByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.JobApiFp)(this.configuration).getFarmLotaJobByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get OTA job by device ID.
     * @param {string} deviceId Unique ID of device, there is no validation so can be any types of devices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    JobApi.prototype.getOtaJobByDeviceID = function (deviceId, options) {
        var _this = this;
        return (0, exports.JobApiFp)(this.configuration).getOtaJobByDeviceID(deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get OTA job by release channel ID.
     * @param {string} releaseChannelId Unique ID of release channel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    JobApi.prototype.getOtaJobByReleaseChannelID = function (releaseChannelId, options) {
        var _this = this;
        return (0, exports.JobApiFp)(this.configuration).getOtaJobByReleaseChannelID(releaseChannelId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm lota job by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {IUpdateFarmLotaJobRequestDTO} [iUpdateFarmLotaJobRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    JobApi.prototype.updateFarmLotaJobByFarmID = function (farmId, iUpdateFarmLotaJobRequestDTO, options) {
        var _this = this;
        return (0, exports.JobApiFp)(this.configuration).updateFarmLotaJobByFarmID(farmId, iUpdateFarmLotaJobRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobApi;
}(base_1.BaseAPI));
exports.JobApi = JobApi;
/**
 * ReleaseChannelApi - axios parameter creator
 * @export
 */
var ReleaseChannelApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create release channel.
         * @param {ICreateReleaseChannelRequestDTO} [iCreateReleaseChannelRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReleaseChannel: function (iCreateReleaseChannelRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/release-channel";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateReleaseChannelRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReleaseChannelByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteReleaseChannelByID', 'id', id);
                    localVarPath = "/ota/release-channel/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all release channel mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannelMappings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/release-channel/mapping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all release channel mappings by release channel ID.
         * @param {string} releaseChannelId Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannelMappingsByReleaseChannelID: function (releaseChannelId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'releaseChannelId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllReleaseChannelMappingsByReleaseChannelID', 'releaseChannelId', releaseChannelId);
                    localVarPath = "/ota/release-channel/mapping/release-channel/{releaseChannelId}"
                        .replace("{".concat("releaseChannelId", "}"), encodeURIComponent(String(releaseChannelId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all release channels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannels: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ota/release-channel";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseChannelByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getReleaseChannelByID', 'id', id);
                    localVarPath = "/ota/release-channel/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get release channel mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseChannelMappingByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getReleaseChannelMappingByFarmID', 'farmId', farmId);
                    localVarPath = "/ota/release-channel/mapping/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {IUpdateReleaseChannelRequestDTO} [iUpdateReleaseChannelRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseChannelByID: function (id, iUpdateReleaseChannelRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateReleaseChannelByID', 'id', id);
                    localVarPath = "/ota/release-channel/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateReleaseChannelRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update release channel mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateReleaseChannelMappingRequestDTO} [iUpdateReleaseChannelMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseChannelMappingByFarmID: function (farmId, iUpdateReleaseChannelMappingRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('updateReleaseChannelMappingByFarmID', 'farmId', farmId);
                    localVarPath = "/ota/release-channel/mapping/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateReleaseChannelMappingRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ReleaseChannelApiAxiosParamCreator = ReleaseChannelApiAxiosParamCreator;
/**
 * ReleaseChannelApi - functional programming interface
 * @export
 */
var ReleaseChannelApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ReleaseChannelApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create release channel.
         * @param {ICreateReleaseChannelRequestDTO} [iCreateReleaseChannelRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReleaseChannel: function (iCreateReleaseChannelRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createReleaseChannel(iCreateReleaseChannelRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReleaseChannelByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteReleaseChannelByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all release channel mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannelMappings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllReleaseChannelMappings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all release channel mappings by release channel ID.
         * @param {string} releaseChannelId Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannelMappingsByReleaseChannelID: function (releaseChannelId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllReleaseChannelMappingsByReleaseChannelID(releaseChannelId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all release channels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannels: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllReleaseChannels(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseChannelByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReleaseChannelByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get release channel mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseChannelMappingByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReleaseChannelMappingByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {IUpdateReleaseChannelRequestDTO} [iUpdateReleaseChannelRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseChannelByID: function (id, iUpdateReleaseChannelRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateReleaseChannelByID(id, iUpdateReleaseChannelRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update release channel mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateReleaseChannelMappingRequestDTO} [iUpdateReleaseChannelMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseChannelMappingByFarmID: function (farmId, iUpdateReleaseChannelMappingRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateReleaseChannelMappingByFarmID(farmId, iUpdateReleaseChannelMappingRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ReleaseChannelApiFp = ReleaseChannelApiFp;
/**
 * ReleaseChannelApi - factory interface
 * @export
 */
var ReleaseChannelApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ReleaseChannelApiFp)(configuration);
    return {
        /**
         * Create release channel.
         * @param {ICreateReleaseChannelRequestDTO} [iCreateReleaseChannelRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReleaseChannel: function (iCreateReleaseChannelRequestDTO, options) {
            return localVarFp.createReleaseChannel(iCreateReleaseChannelRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReleaseChannelByID: function (id, options) {
            return localVarFp.deleteReleaseChannelByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all release channel mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannelMappings: function (options) {
            return localVarFp.getAllReleaseChannelMappings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all release channel mappings by release channel ID.
         * @param {string} releaseChannelId Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannelMappingsByReleaseChannelID: function (releaseChannelId, options) {
            return localVarFp.getAllReleaseChannelMappingsByReleaseChannelID(releaseChannelId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all release channels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseChannels: function (options) {
            return localVarFp.getAllReleaseChannels(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseChannelByID: function (id, options) {
            return localVarFp.getReleaseChannelByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get release channel mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseChannelMappingByFarmID: function (farmId, options) {
            return localVarFp.getReleaseChannelMappingByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update release channel by ID.
         * @param {string} id Unique ID of release channel.
         * @param {IUpdateReleaseChannelRequestDTO} [iUpdateReleaseChannelRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseChannelByID: function (id, iUpdateReleaseChannelRequestDTO, options) {
            return localVarFp.updateReleaseChannelByID(id, iUpdateReleaseChannelRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update release channel mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateReleaseChannelMappingRequestDTO} [iUpdateReleaseChannelMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseChannelMappingByFarmID: function (farmId, iUpdateReleaseChannelMappingRequestDTO, options) {
            return localVarFp.updateReleaseChannelMappingByFarmID(farmId, iUpdateReleaseChannelMappingRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ReleaseChannelApiFactory = ReleaseChannelApiFactory;
/**
 * ReleaseChannelApi - object-oriented interface
 * @export
 * @class ReleaseChannelApi
 * @extends {BaseAPI}
 */
var ReleaseChannelApi = /** @class */ (function (_super) {
    __extends(ReleaseChannelApi, _super);
    function ReleaseChannelApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create release channel.
     * @param {ICreateReleaseChannelRequestDTO} [iCreateReleaseChannelRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.createReleaseChannel = function (iCreateReleaseChannelRequestDTO, options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).createReleaseChannel(iCreateReleaseChannelRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete release channel by ID.
     * @param {string} id Unique ID of release channel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.deleteReleaseChannelByID = function (id, options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).deleteReleaseChannelByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all release channel mappings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.getAllReleaseChannelMappings = function (options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).getAllReleaseChannelMappings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all release channel mappings by release channel ID.
     * @param {string} releaseChannelId Unique ID of release channel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.getAllReleaseChannelMappingsByReleaseChannelID = function (releaseChannelId, options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).getAllReleaseChannelMappingsByReleaseChannelID(releaseChannelId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all release channels.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.getAllReleaseChannels = function (options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).getAllReleaseChannels(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get release channel by ID.
     * @param {string} id Unique ID of release channel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.getReleaseChannelByID = function (id, options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).getReleaseChannelByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get release channel mapping by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.getReleaseChannelMappingByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).getReleaseChannelMappingByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update release channel by ID.
     * @param {string} id Unique ID of release channel.
     * @param {IUpdateReleaseChannelRequestDTO} [iUpdateReleaseChannelRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.updateReleaseChannelByID = function (id, iUpdateReleaseChannelRequestDTO, options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).updateReleaseChannelByID(id, iUpdateReleaseChannelRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update release channel mapping by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {IUpdateReleaseChannelMappingRequestDTO} [iUpdateReleaseChannelMappingRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseChannelApi
     */
    ReleaseChannelApi.prototype.updateReleaseChannelMappingByFarmID = function (farmId, iUpdateReleaseChannelMappingRequestDTO, options) {
        var _this = this;
        return (0, exports.ReleaseChannelApiFp)(this.configuration).updateReleaseChannelMappingByFarmID(farmId, iUpdateReleaseChannelMappingRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReleaseChannelApi;
}(base_1.BaseAPI));
exports.ReleaseChannelApi = ReleaseChannelApi;
